import React from 'react';
import '../css/Separator.css';

const Separator = ({data}) => {
    if(data.separate === true){
        return (
            <div className={`separator ${data.mode}`}></div>
        );
    }
    else{
        return (<></>);
    }
}

export default Separator;
